import React, { useState } from 'react';
import { callSSELogout } from '../NotificationsAlertsSidebar/notificationSSE';
import Avatar from '../Avatar';
import ManageProfile from 'src/features/settings/ManageProfile';
import Popover from '../Popover';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';

import { getCookie } from 'src/utils/cookies';
import { jwtDecode } from 'src/utils/jwtDecode';
import { useNavigate } from 'react-router-dom';
import { removeCookie } from 'src/utils/cookies';
import { AppDispatch } from 'src/app/rootStore';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCurrentClientIndex,
  setFeatureFlags,
  setLinkedInConfigured,
  setTPAccountFilters,
  setTPAccountFiltersConfigData,
  setTPContactFilters,
  setTPContactsFiltersConfigData,
  setTrailPeriodAction,
  setWebAccountFilters,
  setWebAccountFiltersConfigData,
  setWebContactFilters,
  setWebContactFiltersConfigData,
  userClientAddAction,
  userEmail,
  setUserTenantTypeAction,
} from 'src/store/login';
import logOutChrome from 'src/utils/logOutChrome';
import useZustandStore from 'src/app/useZustandStore';
import { setMDQSFilters } from 'src/store/login/multiDb-filters.actions';
import { setCreateICPFilters } from 'src/store/login/create-icp-filters.actions';
import { setCreatePlaybookFilters } from 'src/store/login/create-playbook-filters.actions';
import { setSourceContactsFilters } from 'src/store/slices/sourceContactsFilters';
import { setArchivedContactsFilters } from 'src/store/slices/archivedContactsFilters';
import { setArchivedAccountsFilters } from 'src/store/slices/archivedAccountFilters';
import { setEnrichmentLogsFilters } from 'src/store/slices/enrichmentLogsFilters';
import { setEnrichmentLogsAccountFilters } from 'src/store/slices/enrichmentLogsAccountFilters';
import { generateProfilePicture, isLongLink } from 'src/utils/utilityMethods';
import { CHROME_EXTENSION_ID, BLUEBERRY_EXTENSION_ID } from 'src/constants/env';
import { featureFlagsInitialState, openEditProfileKey } from 'src/constants/constants';
import { setAdminFeatureFlags } from 'src/store/login/adminfeature-flags.actions';
import { trackProfileEdit, trackProfileSignOut } from 'src/mix-panel/profile/functions';
import { ListSubheader } from '@mui/material';
import { useProfile } from 'src/hooks/useProfile';
import LinkedInIcon from 'src/assets/icons/small-linkedin-icon.svg';
import { useSearchParams } from 'react-router-dom';
import { fetchUserDetails, clearUserDetails } from 'src/store/slices/userDetails';
import { setShowOldNotifications } from 'src/store/notifications/notifications.actions';
import { clearColumnWidths } from 'src/store/slices/columnResize';
import { resetAllTableHeaders } from 'src/store/slices/allTableHeaders';
import { resetCredit } from 'src/store/credit/credit.slice';
export default function Profile({
  expanded = false,
  triggerCollapseNav,
  closePopoverRef,
  setIsPopoverOpen,
}: {
  expanded?: boolean;
  triggerCollapseNav?: () => void;
  closePopoverRef?: React.MutableRefObject<(() => void) | null>;
  setIsPopoverOpen?: (isOpen: boolean) => void;
}) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLImageElement | null>(null);
  const [openManageProfile, setOpenManageProfile] = React.useState(false);
  const { isLinkedInIdConfigured } = useProfile();
  const navigate = useNavigate();
  const token = getCookie('user');
  const emailId = jwtDecode(token);
  const dispatch = useDispatch<AppDispatch>();
  const emailID = useSelector(userEmail);
  const [searchParams, setSearchParams] = useSearchParams();
  const oepnEditProfileParam = searchParams.get('oepnEditProfile') === 'true';
  const { clientName } = useProfile();
  const closeTimeoutRef = React.useRef<number | null>(null);
  const userDetails = useSelector((state: any) => state.userDetails);

  // Clear any pending close timeout
  const cancelCloseTimeout = React.useCallback(() => {
    if (closeTimeoutRef.current !== null) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
  }, []);

  const logout = (e: React.FormEvent) => {
    trackProfileSignOut(emailID, clientName);
    dispatch(setTPAccountFiltersConfigData([]));
    dispatch(setWebAccountFiltersConfigData([]));
    dispatch(setWebContactFiltersConfigData([]));
    dispatch(setTPContactsFiltersConfigData([]));
    dispatch(setTPContactFilters({}));
    dispatch(setTPAccountFilters({}));
    dispatch(setWebAccountFilters({}));
    dispatch(setWebContactFilters({}));
    dispatch(setMDQSFilters({}));
    dispatch(setCreateICPFilters({}));
    dispatch(setCreatePlaybookFilters({}));
    dispatch(setSourceContactsFilters({}));
    dispatch(setArchivedContactsFilters({}));
    dispatch(setArchivedAccountsFilters({}));
    dispatch(setEnrichmentLogsFilters({}));
    dispatch(setEnrichmentLogsAccountFilters({}));
    const { setTalFiltersCopy, setTclFiltersCopy, setWebAccountFiltersCopy, setWebContactFiltersCopy } = useZustandStore.getState();
    setTalFiltersCopy({});
    setTclFiltersCopy({});
    setWebAccountFiltersCopy({});
    setWebContactFiltersCopy({});
    dispatch(setTrailPeriodAction({ trialPeriod: 0 }));
    dispatch(setUserTenantTypeAction({ tenantType: '' }));
    localStorage.removeItem('PrevFiltersWAL');
    localStorage.removeItem('PrevWalSummaryData');
    localStorage.removeItem('PrevFiltersWCL');
    localStorage.removeItem('PrevWclSummaryData');
    dispatch(setFeatureFlags(featureFlagsInitialState));
    dispatch(setAdminFeatureFlags(featureFlagsInitialState));
    dispatch(userClientAddAction({ clientData: [{ CustomerKey: '', CustomerName: '', key: '' }] }));
    const extensionId = sessionStorage.getItem('extension_id') || CHROME_EXTENSION_ID;
    const blueberryExtensionId = BLUEBERRY_EXTENSION_ID;
    e.preventDefault();
    callSSELogout();
    dispatch(setCurrentClientIndex({ clientIndex: 0 }));
    removeCookie('user');
    removeCookie('refresh');
    removeCookie('refreshToken');
    removeCookie('clientKey');
    removeCookie('migrated');
    removeCookie('cmpName');
    const peopleColumnsManager = localStorage.getItem('peopleColumnsManager_29');
    localStorage.clear();
    if (peopleColumnsManager) {
      localStorage.setItem('peopleColumnsManager_29', peopleColumnsManager);
    }
    logOutChrome(extensionId);
    logOutChrome(blueberryExtensionId);
    dispatch(setShowOldNotifications(true));
    dispatch(clearColumnWidths());
    dispatch(resetAllTableHeaders());
    dispatch(clearUserDetails());
    dispatch(resetCredit());
    navigate('/login');
    localStorage.setItem('chatbotLastOpened', new Date().toDateString());
  };
  const handleClick = (event: React.MouseEvent<HTMLImageElement>) => {
    cancelCloseTimeout(); // Cancel any pending close
    setAnchorEl(event.currentTarget);
    setIsPopoverOpen && setIsPopoverOpen(true);
  };

  const handleClose = React.useCallback(() => {
    cancelCloseTimeout(); // Cancel any pending delayed close
    setAnchorEl(null);
    setIsPopoverOpen && setIsPopoverOpen(false);
    triggerCollapseNav && triggerCollapseNav();
  }, [triggerCollapseNav, setIsPopoverOpen, cancelCloseTimeout]);

  // Delayed close for when mouse leaves popover
  const handlePopoverMouseLeave = React.useCallback(() => {
    // Add a small delay before closing to allow moving back to navbar
    closeTimeoutRef.current = window.setTimeout(() => {
      handleClose();
    }, 200); // 200ms delay
  }, [handleClose]);

  // Cancel close when mouse re-enters popover
  const handlePopoverMouseEnter = React.useCallback(() => {
    cancelCloseTimeout();
  }, [cancelCloseTimeout]);

  // Register the close function to the ref so parent can close the popover
  React.useEffect(() => {
    if (closePopoverRef) {
      closePopoverRef.current = handleClose;
    }
    return () => {
      if (closePopoverRef) {
        closePopoverRef.current = null;
      }
    };
  }, [closePopoverRef, handleClose]);

  const handleManageProfile = () => {
    trackProfileEdit(clientName);
    setOpenManageProfile(true);
    handleClose();
  };
  const redirectToLinkedIn = (url: string) => {
    isLongLink(url) ? window.open(url) : window.open(`http://${url}`);
  };

  const getUserDetails = () => {
    if (!userDetails?.data?.name) {
      dispatch(fetchUserDetails({ email: emailID }));
    }
  };

  React.useEffect(() => {
    getUserDetails();
  }, [clientName]);

  React.useEffect(() => {
    if (oepnEditProfileParam) {
      setOpenManageProfile(true);
      const params = new URLSearchParams(searchParams);
      params.delete(openEditProfileKey);
      setSearchParams(params, { replace: true });
    }
  }, [oepnEditProfileParam]);

  // Cleanup timeout on unmount
  React.useEffect(() => {
    return () => {
      cancelCloseTimeout();
    };
  }, [cancelCloseTimeout]);

  return (
    <>
      <div
        className={`main-nav-bar-avatar-wrapper ${expanded ? 'profile-wrapper-expanded' : 'profile-wrapper-collapsed'
          }`}
        onMouseEnter={cancelCloseTimeout}
      >
        <div
          className={`main-nav-bar-avatar ${anchorEl ? '-active' : ''}`}
          onClick={handleClick}
          onMouseEnter={cancelCloseTimeout}
        >
          <Avatar
            name={userDetails?.data?.name || emailId.email}
            src={generateProfilePicture(emailId?.email || '')}
            width={40}
            height={40}
          />
          {expanded && <p className="avatar-user-name">{userDetails?.data?.name || emailId.email}</p>}
        </div>
        <Popover
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'left',
          }}
          slotProps={{
            paper: {
              sx: {
                marginLeft: 0,
                marginTop: 1,
              },
              className: 'mui-profile-popover',
              onMouseEnter: handlePopoverMouseEnter,
              onMouseLeave: handlePopoverMouseLeave,
            },
          }}
        >
          <List
            sx={{
              width: '100%',
              maxWidth: 229,
              minWidth: 205,
              bgcolor: 'background.paper',
              padding: 0,
            }}
            className="profile-list-component"
            component="nav"
            subheader={
              <ListSubheader>
                <div className="profile-sub-header">
                  <p className="client-name">
                    {clientName}{' '}
                    {isLinkedInIdConfigured && isLinkedInIdConfigured.length > 0 && (
                      <span>
                        <img src={LinkedInIcon} alt="linkedin-icon" onClick={() => redirectToLinkedIn(isLinkedInIdConfigured)} />
                      </span>
                    )}
                  </p>
                  <p className="client-email">{emailID}</p>
                </div>
              </ListSubheader>
            }
          >
            <ListItemButton
              onClick={handleManageProfile}
              id="profile-nav-bar-manage-profile-list-item-button"
              disableRipple
            >
              <span className="profile-menu-item">
                <ManageProfileSvg />
                <p className="manage-profile">Manage Profile</p>
              </span>
            </ListItemButton>
            <ListItemButton
              onClick={logout}
              id="profile-nav-bar-sign-out-list-item-button"
              disableRipple
            >
              <span className="profile-menu-item">
                <SignOutSvg />
                <p className="signout-text">Sign out</p>
              </span>
            </ListItemButton>
          </List>
        </Popover>
      </div>
      {openManageProfile && (
        <ManageProfile
          setOpenManageProfile={setOpenManageProfile}
          openManageProfile={openManageProfile}
        />
      )}
    </>
  );
}

const ManageProfileSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        opacity="0.2"
        d="M14 8.0003C14.0009 8.84175 13.8244 9.67393 13.4819 10.4425C13.1394 11.2111 12.6387 11.8989 12.0125 12.4609C11.636 11.7204 11.0618 11.0985 10.3536 10.6642C9.6454 10.2299 8.83078 10.0001 8 10.0003C8.49445 10.0003 8.9778 9.85368 9.38893 9.57897C9.80005 9.30427 10.1205 8.91382 10.3097 8.45701C10.4989 8.00019 10.5484 7.49753 10.452 7.01257C10.3555 6.52762 10.1174 6.08216 9.76777 5.73253C9.41814 5.3829 8.97268 5.1448 8.48773 5.04834C8.00277 4.95187 7.50011 5.00138 7.04329 5.1906C6.58648 5.37982 6.19603 5.70025 5.92133 6.11137C5.64662 6.5225 5.5 7.00585 5.5 7.5003C5.5 8.16334 5.76339 8.79923 6.23223 9.26807C6.70108 9.73691 7.33696 10.0003 8 10.0003C7.16922 10.0001 6.3546 10.2299 5.64639 10.6642C4.93817 11.0985 4.36401 11.7204 3.9875 12.4609C3.24391 11.7921 2.67931 10.948 2.34504 10.0053C2.01077 9.06271 1.91743 8.05148 2.07352 7.0636C2.22961 6.07571 2.63017 5.14252 3.23878 4.34887C3.84739 3.55522 4.64473 2.9263 5.55831 2.51929C6.47189 2.11229 7.47272 1.94011 8.46979 2.01842C9.46686 2.09673 10.4285 2.42304 11.2674 2.96768C12.1062 3.51232 12.7956 4.25801 13.2728 5.13694C13.7501 6.01587 14.0001 7.00016 14 8.0003Z"
        fill="#191918"
      />
      <path
        d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM4.63 12.3438C4.99171 11.7781 5.49001 11.3125 6.07895 10.99C6.6679 10.6676 7.32855 10.4985 8 10.4985C8.67146 10.4985 9.3321 10.6676 9.92105 10.99C10.51 11.3125 11.0083 11.7781 11.37 12.3438C10.4065 13.0931 9.22064 13.5 8 13.5C6.77936 13.5 5.59354 13.0931 4.63 12.3438ZM6 7.5C6 7.10444 6.1173 6.71776 6.33706 6.38886C6.55683 6.05996 6.86918 5.80362 7.23464 5.65224C7.60009 5.50087 8.00222 5.46126 8.39018 5.53843C8.77815 5.6156 9.13451 5.80608 9.41422 6.08579C9.69392 6.36549 9.8844 6.72186 9.96157 7.10982C10.0387 7.49778 9.99914 7.89991 9.84776 8.26537C9.69639 8.63082 9.44004 8.94318 9.11114 9.16294C8.78224 9.3827 8.39557 9.5 8 9.5C7.46957 9.5 6.96086 9.28929 6.58579 8.91421C6.21072 8.53914 6 8.03043 6 7.5ZM12.11 11.6506C11.5524 10.8425 10.7682 10.2174 9.85625 9.85375C10.3461 9.4679 10.7036 8.93899 10.879 8.34056C11.0543 7.74213 11.0388 7.10393 10.8346 6.51472C10.6305 5.9255 10.2477 5.41455 9.73971 5.05293C9.23168 4.69131 8.62359 4.49699 8 4.49699C7.37641 4.49699 6.76832 4.69131 6.26029 5.05293C5.75226 5.41455 5.36955 5.9255 5.16537 6.51472C4.96119 7.10393 4.9457 7.74213 5.12105 8.34056C5.2964 8.93899 5.65387 9.4679 6.14375 9.85375C5.23176 10.2174 4.44765 10.8425 3.89 11.6506C3.18536 10.8582 2.7248 9.87903 2.56378 8.83094C2.40276 7.78285 2.54816 6.71056 2.98245 5.74319C3.41675 4.77582 4.12142 3.95461 5.01163 3.37846C5.90184 2.80231 6.93962 2.49578 8 2.49578C9.06039 2.49578 10.0982 2.80231 10.9884 3.37846C11.8786 3.95461 12.5833 4.77582 13.0176 5.74319C13.4518 6.71056 13.5972 7.78285 13.4362 8.83094C13.2752 9.87903 12.8146 10.8582 12.11 11.6506Z"
        fill="#191918"
      />
    </svg>
  );
};

const SignOutSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        opacity="0.2"
        d="M14 3.5V12.5C14 12.7652 13.8946 13.0196 13.7071 13.2071C13.5196 13.3946 13.2652 13.5 13 13.5H3V2.5H13C13.2652 2.5 13.5196 2.60536 13.7071 2.79289C13.8946 2.98043 14 3.23478 14 3.5Z"
        fill="#E02424"
      />
      <path
        d="M7.5 13.5C7.5 13.6326 7.44732 13.7598 7.35355 13.8536C7.25979 13.9473 7.13261 14 7 14H3C2.86739 14 2.74021 13.9473 2.64645 13.8536C2.55268 13.7598 2.5 13.6326 2.5 13.5V2.5C2.5 2.36739 2.55268 2.24021 2.64645 2.14645C2.74021 2.05268 2.86739 2 3 2H7C7.13261 2 7.25979 2.05268 7.35355 2.14645C7.44732 2.24021 7.5 2.36739 7.5 2.5C7.5 2.63261 7.44732 2.75979 7.35355 2.85355C7.25979 2.94732 7.13261 3 7 3H3.5V13H7C7.13261 13 7.25979 13.0527 7.35355 13.1464C7.44732 13.2402 7.5 13.3674 7.5 13.5ZM14.3538 7.64625L11.8538 5.14625C11.7599 5.05243 11.6327 4.99972 11.5 4.99972C11.3673 4.99972 11.2401 5.05243 11.1462 5.14625C11.0524 5.24007 10.9997 5.36732 10.9997 5.5C10.9997 5.63268 11.0524 5.75993 11.1462 5.85375L12.7931 7.5H7C6.86739 7.5 6.74021 7.55268 6.64645 7.64645C6.55268 7.74021 6.5 7.86739 6.5 8C6.5 8.13261 6.55268 8.25979 6.64645 8.35355C6.74021 8.44732 6.86739 8.5 7 8.5H12.7931L11.1462 10.1462C11.0524 10.2401 10.9997 10.3673 10.9997 10.5C10.9997 10.6327 11.0524 10.7599 11.1462 10.8538C11.2401 10.9476 11.3673 11.0003 11.5 11.0003C11.6327 11.0003 11.7599 10.9476 11.8538 10.8538L14.3538 8.35375C14.4002 8.30731 14.4371 8.25217 14.4623 8.19147C14.4874 8.13077 14.5004 8.06571 14.5004 8C14.5004 7.93429 14.4874 7.86923 14.4623 7.80853C14.4371 7.74783 14.4002 7.69269 14.3538 7.64625Z"
        fill="#E02424"
      />
    </svg>
  );
};
